import React from 'react';

const DEFAULT_ICON_SIZE = { w: 24, h: 24 };

type Props = {
  w?: number;
  h?: number;
  className?: string;
};

const CryptoComIcon = ({ className, w, h }: Props): JSX.Element => {
  return (
    <svg
      width={w || DEFAULT_ICON_SIZE.w}
      height={h || DEFAULT_ICON_SIZE.h}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g fillRule="nonzero" fill="none">
        <path d="M12 0 1 6v12l11 6 11-6V6L12 0zm0 0L1 6v12l11 6 11-6V6L12 0z" fill="#FFF" />
        <path
          d="M16.343 19.313h-1.565l-1.874-1.625v-.834l1.94-1.75v-2.77l2.535-1.563 2.888 2.062-3.924 6.48zm-6.481-4.375.286-2.605L9.2 10h5.6l-.926 2.333.264 2.604H9.862zm1.278 2.75-1.873 1.645H7.679l-3.946-6.5 2.91-2.041L9.2 12.333v2.771l1.94 1.75v.834zm-3.483-12.5h8.664l1.036 4.166H6.643l1.014-4.166zM12 0 1 6v12l11 6 11-6V6L12 0z"
          fill="#03316C"
        />
      </g>
    </svg>
  );
};

CryptoComIcon.ICON_SIZE = DEFAULT_ICON_SIZE;

export default CryptoComIcon;
